<template>
    <div class="warp">
        <div class="echarts" ref="echarts"></div>
    </div>
</template>
<script>
import echarts from 'echarts'
export default {
    name: 'echartsLine',
    props: ['trafficEchartsData'],
    data() {
        return {
            conentviewYdata: [5, 7, 8, 10, 15, 19, 17, 18, 14, 12, 6, 5, 5, 7, 8, 10, 15, 19, 17, 18, 14, 12, 6, 5, 30],
            conentvisitYdata: [3, 5, 6, 9, 12, 16, 15, 11, 8, 5, 3, 1, 3, 5, 6, 9, 12, 16, 15, 11, 8, 5, 3, 1, 23],
            xdata: []
        }
    },
    watch: {
        trafficEchartsData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.initChart(this.trafficEchartsData)
            })
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    mounted() {},
    methods: {
        initChart(datas) {
            this.conentviewYdata = datas.conentviewYdata
            this.conentvisitYdata = datas.conentvisitYdata
            this.xdata = datas.xdata
            this.chart = echarts.init(this.$refs.echarts)
            this.chart.setOption(this.getOption())
        },
        getOption: function() {
            return {
                color: ['#409EFF', '#67C23A'],
                title: {
                    subtext: '流量趋势',
                    left: 'left',
                    subtextStyle: {
                        color: '#606266'
                    }
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['浏览量', '访客数'],
                    icon: 'circle',
                    itemWidth: 10, // 设置宽度
                    itemHeight: 10 // 设置高度
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show: false
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    // data: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24']
                    data: this.xdata
                },
                yAxis: {
                    type: 'value',
                    name: '',
                    // nameTextStyle: {
                    //     color: 'red'
                    // },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: ['#f2f2f2'],
                            type: 'dashed'
                        }
                    }
                },
                series: [
                    {
                        name: '浏览量',
                        type: 'line',
                        data: this.conentviewYdata
                    },
                    {
                        name: '访客数',
                        type: 'line',
                        data: this.conentvisitYdata
                    }
                ]
            }
        }
    }
}
</script>
<style scoped>
.warp {
    width: 100%;
    height: 100%;
}
.echarts {
    width: 100%;
    height: 100%;
}
</style>